import React from 'react';
import { Image, Slide } from 'pure-react-carousel';
import { cn } from '@express-labs/raven-tools';
import IconV2 from '../../../IconV2/IconV2';
import s from './RenderSlideOutfits.scss';

export type RenderSlideOutfitsProps = {
  /**
   * The array index number of this slide.  This same number is used in Dot, and thumbnail buttons
   * to link them together.  For example, clicking on Dot 3 moves slide 3 into the leftmost
   * slot in the Carousel viewport.  See pure-react-carousel documentation for more info.
   * This number is generated automatically in Carousel.
   */
  i: number;

  /**
   * a unique id for the carousel. This number is used to help create unique css id's and class
   * names so that you can have more than one carousel on the page and style them differently,
   * or reference a dom element via their unique id attribute name via javascript.
   * This number is generated automatically in Carousel and passed in.
   */
  uid: number;

  /**
   * A url to an large (zoomed in or modal) image.  Passed in by Carousel.
   */
  large: string;

  /**
   * A url to a "normal sized" image. Not a thumbnail, and not a large image.
   * This is "optional" for backwards compatibility, but as of 11/12/18 we should be using
   * this to avoid "fuzzy images" due to the browser downsampling a large image into a small
   * space.
   */
  main?: string;

  // Action handler for clicks on the image.  Passed in by Carousel.
  onClick: (i: number, ev: React.MouseEvent<HTMLElement>) => void;

  onKeyDown: (i: number, ev: React.KeyboardEvent<HTMLElement>) => void;

  selectedItem?: number;

  isMobile?: boolean;

  isQuickView?: boolean;

  ariaLabel?: string;

  totalOfProducts?: number;

  onModelImage?: boolean;
};
export default class RenderSlideOutfits extends React.PureComponent<RenderSlideOutfitsProps> {
  constructor(props: RenderSlideOutfitsProps) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleKeyEvent = this.handleKeyEvent.bind(this);
  }

  handleOnClick(ev: React.MouseEvent<HTMLElement>) {
    ev.persist();
    this.props.onClick(this.props.i, ev);
  }

  handleKeyEvent(ev: React.KeyboardEvent<HTMLElement>) {
    ev.persist();
    const { key } = ev;
    if (key === 'Enter' || key === ' ') {
      this.props.onKeyDown(this.props.i, ev);
    }
  }

  render() {
    const {
      i,
      large,
      main,
      uid,
      selectedItem,
      isMobile = false,
      isQuickView = false,
      ariaLabel = '',
      totalOfProducts = 0,
      onModelImage = false,
    } = this.props;

    const classNamesSlide = cn(!isMobile && s.slide, isMobile && s.slideMobile);
    const classNamesInnerSlide = cn(
      s.slideInnerCard,
      selectedItem === i && s.selected,
      isQuickView && s.slideOutfitsQuickView
    );

    const classNamesImage = cn(
      s.outfitsImagesPresentation,
      isQuickView && s.imageOutfitsQuickView
    );

    return (
      <Slide
        aria-label={
          isQuickView
            ? `Product #${i + 1} of ${totalOfProducts} : ${ariaLabel}`
            : `Outfit #${
                i + 1
              } of ${totalOfProducts}, list of products: ${ariaLabel}`
        }
        className={cn(s.resetButton, 'focus-on-modal-close')}
        id={`carousel__slide--${uid}--${i}`}
        index={i}
        innerClassName={classNamesSlide}
        key={large}
        onClick={this.handleOnClick}
        onKeyDown={this.handleKeyEvent}
        tabIndex={0}
        tag="button"
      >
        <div
          className={cn(
            classNamesInnerSlide,
            onModelImage && s.shopTheLookContainer
          )}
        >
          <Image
            data-image="this should be an img tag"
            hasMasterSpinner={false}
            className={classNamesImage}
            tag="img"
            src={main || large}
          />
          {onModelImage && (
            <div className={s.shopTheLookBadge} data-testid="shop-the-look">
              <IconV2 icon="shopTheLookBadge" />
            </div>
          )}
        </div>
        {!isQuickView && <p className={s.cardProductLabel}>GET THE LOOK</p>}
      </Slide>
    );
  }
}
